import { useState } from "react"
import "./pagesReader.scss"
import PagesControl from "./pagesControl"

interface IProps {
    pages:string[]
    openedPage?:number
    timer?:number
    close:()=>void
}

export default function PagesReader({pages, openedPage, timer, close}:IProps) {
    const [activePage, setActivePage] = useState(openedPage ? openedPage : 0)
    const next = () => {
        let nextPage = 0
        if (activePage + 1 < pages.length) {
            nextPage = activePage + 1
        }
        setActivePage(nextPage)
    }
    const previous = () => {
        let previousPage = 0
        if (activePage > 0) {
            previousPage = activePage - 1
        }
        setActivePage(previousPage)
    }
    return (
        <div id="pages-reader">
            <div className="active-page">
                <img src={pages[activePage]}  />
            </div>
            <PagesControl close={close} timer={timer} next={next} previous={previous} pageNumber={activePage} totalPages={pages.length} />
        </div>
    )
}